import React from 'react'
import { cx } from '@/lib/utils'
import styles from './FormTextarea.module.scss'

interface FormTextareaProps {
  id: string
  label: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  error?: string
  required?: boolean
  rows?: number
}

export const FormTextarea: React.FC<FormTextareaProps> = ({
  id, label, value, onChange, placeholder, error, required = false, rows = 5,
}) => (
  <div className={styles.field}>
    <label className={styles.label} htmlFor={id}>
      {label}
      {required && <span className={styles.required}>*</span>}
    </label>
    <textarea
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      rows={rows}
      className={cx(styles.textarea, error && styles.textareaError)}
      required={required}
    />
    {error && <span className={styles.error}>{error}</span>}
  </div>
)
